import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import HomePage from '../containers/HomePage';
import NotFoundPage from '../components/common/NotFoundPage';

// Sales containers
import SalesPage from "../containers/sales/SalesPage";
import CustomersPage from "../containers/sales/customers/CustomersPage";
import CustomerTabs from "../containers/sales/customers/CustomerTabs";
import NewCustomer from "../containers/sales/customers/NewCustomer";

import CostBreakdownsPage from '../containers/sales/cost-breakdowns/CostBreakdownsPage';
import NewCostBreakdown from "../containers/sales/cost-breakdowns/NewCostBreakdown";
import CostBreakdownTabs from '../containers/sales/cost-breakdowns/CostBreakdownTabs';

import QuotesPage from '../containers/sales/quotes/QuotesPage';
import NewQuote from "../containers/sales/quotes/NewQuote";
import QuoteTabs from '../containers/sales/quotes/QuoteTabs';

import SalesOrdersPage from '../containers/sales/orders/SalesOrdersPage';
import NewSalesOrder from "../containers/sales/orders/NewSalesOrder";
import SalesOrderTabs from '../containers/sales/orders/SalesOrderTabs';

import IssuesPage from '../containers/sales/issues/IssuesPage';
import NewIssue from "../containers/sales/issues/NewIssue";
import IssueTabs from '../containers/sales/issues/IssueTabs';

import SalesInvoicesPage from '../containers/sales/invoices/SalesInvoicesPage';
import NewSalesInvoice from "../containers/sales/invoices/NewSalesInvoices";
import SalesInvoiceTabs from '../containers/sales/invoices/SalesInvoiceTabs';
import SalesProformaInvoicesPage from '../containers/sales/invoices/SalesProformaInvoicesPage';

// Purchases containers
import PurchasesPage from '../containers/purchases/PurchasesPage';
import SuppliersPage from '../containers/purchases/suppliers/SuppliersPage';
import SuppliersTabs from '../containers/purchases/suppliers/SupplierTabs';
import NewSupplier from '../containers/purchases/suppliers/NewSupplier';

import PurchaseOrdersPage from '../containers/purchases/orders/PurchaseOrdersPage';
import NewPurchaseOrder from "../containers/purchases/orders/NewPurchaseOrder";
import PurchaseOrderTabs from '../containers/purchases/orders/PurchaseOrderTabs';

import ReceiptsPage from '../containers/purchases/receipts/ReceiptsPage';
import NewReceipt from "../containers/purchases/receipts/NewReceipt";
import ReceiptTabs from '../containers/purchases/receipts/ReceiptTabs';

import PurchaseInvoicesPage from '../containers/purchases/invoices/PurchaseInvoicesPage';
import NewPurchaseInvoice from "../containers/purchases/invoices/NewPurchaseInvoice";
import PurchaseInvoiceTabs from '../containers/purchases/invoices/PurchaseInvoiceTabs';

// Config Projects containers
import ProjectsPage from '../containers/projects/ProjectsPage';
import NewProject from '../containers/projects/NewProject';
import ProjectTabs from '../containers/projects/ProjectTabs';

// Config Employees containers
import EmployeesPage from '../containers/employees/EmployeesPage';
import NewEmployee from '../containers/employees/NewEmployee';
import EmployeeTabs from '../containers/employees/EmployeeTabs';

// Config Products containers
import ProductsPage from '../containers/configuration/products/ProductsPage';
import ProductTabs from '../containers/configuration/products/ProductTabs';
import NewProduct from '../containers/configuration/products/NewProduct';

// Config Warehouses containers
import WarehousesPage from '../containers/configuration/warehouses/WarehousesPage';
import WarehouseTabs from '../containers/configuration/warehouses/WarehouseTabs';
import NewWarehouse from '../containers/configuration/warehouses/NewWarehouse';

// Config Users containers
import UsersPage from '../containers/configuration/users/UsersPage';
import NewUser from '../containers/configuration/users/NewUser';
import UserDetail from '../containers/configuration/users/UserDetail';

// Config Documents containers
import DocumentsTabs from "../containers/configuration/documents/DocumentsTabs";

// Config Alerts containers
import AlertsPage from '../containers/configuration/alerts/AlertsPage';

class MainRoutes extends Component {

    render() {

        return (
            <Switch>
                {/* Home route */}
                <Route path="/" render={ () => <HomePage {...this.props} /> } exact />

                {/* Sales routes */}
                <Route path="/ventas/resumen" component={SalesPage} exact />
                <Route path="/ventas/clientes" component={CustomersPage} exact />
                <Route path="/ventas/clientes/nuevo" component={NewCustomer} exact />
                <Route path="/ventas/clientes/:customerId" component={CustomerTabs} />
                <Route path="/ventas/escandallos" component={CostBreakdownsPage} exact />
                <Route path="/ventas/escandallos/nuevo" component={NewCostBreakdown} exact />
                <Route path="/ventas/escandallos/:costBreakdownId" component={CostBreakdownTabs} />
                <Route path="/ventas/presupuestos" component={QuotesPage} exact />
                <Route path="/ventas/presupuestos/nuevo" component={NewQuote} exact />
                <Route path="/ventas/presupuestos/:quoteId" component={QuoteTabs} />
                <Route path="/ventas/pedidos" component={SalesOrdersPage} exact />
                <Route path="/ventas/pedidos/nuevo" component={NewSalesOrder} exact />
                <Route path="/ventas/pedidos/:salesOrderId" component={SalesOrderTabs} />
                <Route path="/ventas/albaranes" component={IssuesPage} exact />
                <Route path="/ventas/albaranes/nuevo" component={NewIssue} exact />
                <Route path="/ventas/albaranes/:issueId" component={IssueTabs} />
                <Route path="/ventas/facturas" component={SalesInvoicesPage} exact />
                <Route path="/ventas/facturas/nuevo" component={NewSalesInvoice} exact />
                <Route path="/ventas/facturas/:salesInvoiceId" component={SalesInvoiceTabs} />
                <Route path="/ventas/proforma" component={SalesProformaInvoicesPage} exact />

                {/* Purchases routes */}
                <Route path="/compras/resumen" component={PurchasesPage} exact />
                <Route path="/compras/proveedores" component={SuppliersPage} exact />
                <Route path="/compras/proveedores/nuevo" component={NewSupplier} exact />
                <Route path="/compras/proveedores/:supplierId" component={SuppliersTabs} />
                <Route path="/compras/pedidos" component={PurchaseOrdersPage} exact />
                <Route path="/compras/pedidos/nuevo" component={NewPurchaseOrder} exact />
                <Route path="/compras/pedidos/:purchaseOrderId" component={PurchaseOrderTabs} />
                <Route path="/compras/albaranes" component={ReceiptsPage} exact />
                <Route path="/compras/albaranes/nuevo" component={NewReceipt} exact />
                <Route path="/compras/albaranes/:receiptId" component={ReceiptTabs} />
                <Route path="/compras/facturas" component={PurchaseInvoicesPage} exact />
                <Route path="/compras/facturas/nuevo" component={NewPurchaseInvoice} exact />
                <Route path="/compras/facturas/:purchaseInvoiceId" component={PurchaseInvoiceTabs} />

                {/* Projects routes */}
                <Route path="/proyectos" component={ProjectsPage} exact />
                <Route path="/proyectos/nuevo" component={NewProject} exact />
                <Route path="/proyectos/:projectId" component={ProjectTabs} />

                {/* Employees routes */}
                <Route path="/empleados" component={EmployeesPage} exact />
                <Route path="/empleados/nuevo" component={NewEmployee} exact />
                <Route path="/empleados/:employeeId" component={EmployeeTabs} />

                {/* Config routes */}
                <Route path="/productos" component={ProductsPage} exact />
                <Route path="/productos/nuevo" component={NewProduct} exact />
                <Route path="/productos/:productId" component={ProductTabs} />
                <Route path="/almacenes" component={WarehousesPage} exact />
                <Route path="/almacenes/nuevo" component={NewWarehouse} exact />
                <Route path="/almacenes/:warehouseId" component={WarehouseTabs} />
                <Route path="/usuarios" component={UsersPage} exact />
                <Route path="/usuarios/nuevo" component={NewUser} exact />
                <Route path="/usuarios/:userId" component={UserDetail} />
                <Route path="/documentos" component={DocumentsTabs} />
                <Route path="/alertas" component={AlertsPage} />

                {/* Not found route */}
                <Route component={NotFoundPage}/>
            </Switch>
        );
    }
}

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/routes/MainRoutes.js